export enum MODULES {
  IDENTITIES = 'IDENTITIES',
  APPS = 'APPS',
  CONNECTIONS = 'CONNECTIONS',
  MODULES = 'MODULES',
  NOTICES = 'NOTICES',
  KNOWLEDGEBASE = 'KNOWLEDGEBASE',
  NOTIFICATIONS = 'NOTIFICATIONS',
  MESSAGES = 'MESSAGES',
  LOGS = 'LOGS',
  LOGS_WEB_SERVICE = 'LOGS_WEB_SERVICE',
  MAILBOX = 'MAILBOX',
  AUTHORIZATION_PERMISSIONS = 'AUTHORIZATION_PERMISSIONS',
  AUTHORIZATION_ROLES = 'AUTHORIZATION_ROLES',
  AUTHORIZATION_PRIVILEGES = 'AUTHORIZATION_PRIVILEGES',
  STORAGE_DRIVE = 'STORAGE_DRIVE',
  STORAGE_RECYCLE_BIN = 'STORAGE_TRASH',
  REFERENCES = 'REFERENCES',
  INTEGRATIONS = 'INTEGRATIONS',
  SETUP = 'SETUP',

  // Business
  PROPOSALS = 'PROPOSALS',
  COVER_NOTES = 'COVER_NOTES',
  CUSTOMERS = 'CUSTOMERS',
  ENDORSEMENTS = 'ENDORSEMENTS',
  CLAIMS = 'CLAIMS',
  INVOICES = 'INVOICES',
  RECEIPTS = 'RECEIPTS',
  CAMPAIGN = 'CAMPAIGN',

  // AVO
  LEADS = 'LEADS',
  ACTIVITIES = 'ACTIVITIES',
  REFERRERS = 'REFERRERS',
  AGENTS = 'AGENTS',
  TARGETS = 'TARGETS',
  ACHIEVEMENTS = 'ACHIEVEMENTS',
  RECRUITMENTS = 'RECRUITMENTS',
  COMPETITIONS = 'COMPETITIONS',
  PROMOTIONS = 'PROMOTIONS',
  //POLICIES = 'POLICIES',

  //FOMS
  PAYOUTS = 'PAYOUTS',
  CRON_JOBS = 'CRON_JOBS',

  //ACCOUNTING RELATED
  CHART_OF_ACCOUNTS = 'CHART_OF_ACCOUNTS',
  ENTRIES = 'ENTRIES',
}

export enum MODULE_GROUPS {
  AUTHORIZATION = 'AUTHORIZATION',
  INTEGRATIONS = 'INTEGRATIONS',
  STORAGE = 'STORAGE',
  REFERENCES = 'REFERENCES',
}

export enum MODULE_STATUSES {
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  HIDDEN = 'hidden',
  DISABLE = 'disable',
}
